import { EMPTY_LIST } from '../../constants/common'

export function getBreadcrumbs({ headPath, sub, subMenu, t, title }) {
  if (subMenu.items.length > 0 && sub) {
    const titleSub = subMenu.items.find(item => item.name === sub)?.title

    return [
      { id: title, title, to: headPath },
      ...(titleSub ? [{ id: titleSub, title: t(titleSub) }] : EMPTY_LIST),
    ]
  }

  return [{ id: title, title, to: headPath }]
}
